import { Injectable } from '@angular/core';
import { WmHttpService, ProjectService, I18nService } from "@wms/services";
import { environment } from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class WebserviceService {
  TARGET = 'WebService';
  locale: any;
  API_META: any = {
    invokeRestCall: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservices/invoke",
      method: "POST"
    },
    generateRESTWsdlSettings: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservice/settings",
      method: "POST"
    },
    buildRestService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservice",
      method: "POST"
    },
    updateRestService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservice",
      method: "PUT"
    },
    importWSDL: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/soapservice/import",
      method: "POST",
      headers: {
        'Content-Type': undefined
      }
    },
    uploadWSDL: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/soapservice/import",
      method: "POST",
      headers: {
        'Content-Type': undefined
      }
    },
    uploadOpenAPI: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservice/import",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
    },
    reUploadOpenAPI: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservice/import",
      method: "PUT",
      headers: {
        'Content-Type': 'application/json'
      },
    },
    loadOpenAPI: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservice/load",
      method: "POST"
    },
    loadOpenAPIUrl: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservice/loadUrl",
      method: "POST",
    },
    getOpenAPISecurityConfiguration: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/restservice/:serviceId/config",
      method: "GET",
      headers: {
        'Content-Type': 'application/json'
      }
    },
    setOpenAPISecurityConfiguration: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/restservice/:serviceId/config",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
    },
    updateSource: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/restservice/:serviceId/sources/update",
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
    },
    registerFeedService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/feed/register",
      method: "POST"
    },
    getRESTDetails: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/restservice/:serviceID",
      method: "GET"
    },
    getWSDL: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/soapservice/:serviceID/wsdl",
      method: "GET"
    },
    getBindingProperties: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID/properties",
      method: "GET"
    },
    setBindingProperties: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID/properties",
      method: "POST"
    },
    listTypes: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/types",
      method: "GET"
    },
    getDataTypesByService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:service/types",
      method: "GET"
    },
    listPrefabTypes: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/prefabs/:prefabName/types",
      method: "GET"
    },
    listServicesWithType: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services",
      method: "GET"
    },
    updateMockServer: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID/apimock-services?enableMock=:enableMock",
      method: "PUT"
    },
    pollMockServerStatus: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID/apimock-services",
      method: "GET"
    },
    getServiceClasses: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/serviceClasses",
      method: "GET"
    },
    getServiceMethods: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID/operations",
      method: "GET"
    },
    getServiceOperationParams: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID/operations/:operationID",
      method: "GET"
    },
    invoke: {
      url: '/:serviceFile',
      method: "POST"
    },
    invokeRestService: {
      url: environment.SERVICES_BASE_PATH + "services/:serviceID/:operationID",
      method: "POST"
    },
    invokePrefabRestService: {
      url: '/:serviceID/:operationID',
      method: "POST"
    },
    remove: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID",
      method: "DELETE"
    },
    retrieveServiceOperations: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/services/:serviceId/servicedef",
      method: "GET"
    },
    invokeRuntimeRestCall: {
      url: ''
    },
    buildApiRestService: {
      url: environment.SERVICES_BASE_PATH + "services/restservices/create",
      method: "POST"
    },
    getSoapServiceSettings: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/soapservice/:serviceId/settings",
      method: "GET"
    },
    setSoapServiceSettings: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectId/soapservice/:serviceId/settings",
      method: "POST"
    },
    reImportSoapService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/soapservice/:serviceId/reimport",
      method: "POST",
      headers: {
        'Content-Type': undefined
      }
    },
    configureWebSocketService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/websocketservice/settings",
      method: "POST"
    },
    buildWebSocketService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/websocketservice",
      method: "POST"
    },
    updateWebSocketService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/websocketservice",
      method: "PUT"
    },
    getWebSocketServiceDetails: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/websocketservice/:serviceID",
      method: "GET"
    },
    getSwaggerInfo: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/resources/content/project/services/:serviceID/designtime/:serviceName",
      method: "GET"
    },
    getSwaggerDiff: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID/projectinspect/report",
      method: "POST"
    },
    getStatusUpdate: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/services/:serviceID/projectinspect/status",
      method: "GET"
    },

  }


  uploadOpenAPI(connectionParams: any) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "uploadOpenAPI",
      data: connectionParams.data,
      pathParams: connectionParams.urlParams,
      params: connectionParams.params
    });
  }

  reUploadOpenAPI(connectionParams: any){
    return this.wmHttpService.execute({
      target: "WebService",
      action: "reUploadOpenAPI",
      data: connectionParams.data,
      pathParams: connectionParams.urlParams,
      params: connectionParams.params,
      spinnerInfo : {
        showSpinner: false
      }
  });
  }

  deleteSwagger(urlParams: any) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "remove",
      pathParams: urlParams,
      toasterInfo: {'error': {title: this.locale.MESSAGE_ERROR_TITLE}}
    });
  }
  listServicesWithType(connectionParams: any) {
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'listServicesWithType',
      pathParams: {
        projectID: this.projectService.getProjectId(),
      },
      toasterInfo: {
        error: {
          title: this.locale.MESSAGE_ERROR_TITLE,
          description: this.locale.MESSAGE_ERROR_FETCH_WEB_DATA_SERVICES_DESC,
        },
      },
      spinnerInfo: {
        spinnerMsg: this.locale.LABEL_PREPARING_APIS,
        showSpinner: connectionParams.showSpinner
      },
    });
  }

  setOpenAPISecurityConfiguration(connectionParams: any) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "setOpenAPISecurityConfiguration",
      data: connectionParams.data,
      pathParams: connectionParams.urlParams,
      params: connectionParams.params
    });
  }

  updateSource(pathParams: any) {
    return (this.wmHttpService.execute({
      target: "WebService",
      action: "updateSource",
      pathParams: pathParams,
      spinnerInfo: {
        showSpinner: false
      },
      toasterInfo: {
        'success': { title: this.locale.MESSAGE_SUCCESS_TITLE, description: this.locale.MESSAGE_CODEGEN_RE_GENERATION_SUCCESS },
        'error'  : { title:  this.locale.MESSAGE_ERROR_TITLE, description: this.locale.MESSAGE_ERROR_CODEGEN_DATABASE_DESC}
      }
    }) as Promise<any>);
  }


  updateMockServer(urlParams: any) {
    let toasterInfo: any = {
      'error': { title: this.locale.MESSAGE_ERROR_TITLE }
    }
    urlParams.enableMock === false ?
      toasterInfo['success'] = { title: this.locale.TITLE_MOCK_SERVICE_STOP_SUCCESS, description: this.locale.MESSAGE_MOCK_SERVICE_STOP_SUCCESS.replace("${0}", urlParams.serviceID) }
      : toasterInfo;
    return this.wmHttpService.execute({
      target: "WebService",
      action: "updateMockServer",
      pathParams: urlParams,
      toasterInfo: toasterInfo,
      spinnerInfo: {
        showSpinner: urlParams.showSpinner,
      }
    });
  }

  pollMockServerStatus(urlParams: any) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "pollMockServerStatus",
      pathParams: urlParams,
      spinnerInfo: {
        showSpinner: urlParams.showSpinner,
      }
    });
  }

  testRestService(connectionParams: any) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "invokeRestCall",
      pathParams: connectionParams.pathParams,
      data: connectionParams.data,
      headers: connectionParams.headers,
      spinnerInfo: {
        showSpinner: false
      }
    });
  }

  listTypes(urlParams: any, showSpinner?: boolean) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "listTypes",
      pathParams: urlParams,
      toasterInfo: {
        'error'  : { title: this.locale.MESSAGE_ERROR_TITLE, description: this.locale.MESSAGE_ERROR_LIST_TYPES_DESC }
      },
      spinnerInfo : {
        showSpinner: showSpinner
      }
    });
    // TO DO - successCallback, failureCallback execution
  }

  getDataTypesByService(service: any, showSpinner?: boolean) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "getDataTypesByService",
      pathParams: {
        projectID: this.projectService.getProjectId(),
        service: service
      },
      toasterInfo: {
        'error': {title: this.locale.MESSAGE_ERROR_TITLE, description: this.locale.MESSAGE_ERROR_LIST_TYPES_DESC}
      },
      spinnerInfo: {
        showSpinner: showSpinner
      }
    });
  }

  getOpenAPISecurityConfiguration(connectionParams: any) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "getOpenAPISecurityConfiguration",
      pathParams: connectionParams.urlParams,
      spinnerInfo: {
        showSpinner: connectionParams.showSpinner,
        spinnerMsg: this.locale.LABEL_PREPARING_APIS
      }
    });
    // TO DO - successCallback, failureCallback execution
  }

  loadOpenAPIUrl(connectionParams: any) {
    return this.wmHttpService.execute({
        target: 'WebService',
        action: 'loadOpenAPIUrl',
        data: connectionParams.data,
        pathParams: connectionParams.urlParams,
        params: connectionParams.params
    });
  }

  loadOpenAPI(connectionParams: any) {
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'loadOpenAPI',
      data: connectionParams.data,
      pathParams: connectionParams.urlParams,
      params: connectionParams.params
    });
  }

  getSwaggerFile(connectionParams: any) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "getSwaggerInfo",
      pathParams: connectionParams.urlParams,
      spinnerInfo: {
        showSpinner: connectionParams.showSpinner,
        spinnerMsg: this.locale.LABEL_PREPARING_APIS
      }
    });

  }

  getSwaggerDiff(connectionParams: any){
    return this.wmHttpService.execute({
      target: "WebService",
      action: "getSwaggerDiff",
      data: connectionParams.data,
      pathParams: connectionParams.urlParams,
      params: connectionParams.params,
      spinnerInfo: {
        showSpinner: false
      },
    });
  }

  getStatusUpdate(connectionParams: any){
    return this.wmHttpService.execute({
      target: "WebService",
      action: "getStatusUpdate",
      data: connectionParams.data,
      pathParams: connectionParams.urlParams,
      params: connectionParams.params,
      spinnerInfo : {
      showSpinner: false
    }
    });
  }

  getRESTDetails(connectionParams: any) {
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'getRESTDetails',
      pathParams: connectionParams.urlParams,
      params: connectionParams.params
    })
  }

  getServiceOperations(params: any) {
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'getServiceMethods',
      pathParams: params.urlParams,
      toasterInfo: {
        'error'  : { title: this.locale.MESSAGE_ERROR_TITLE, description: this.locale.MESSAGE_ERROR_FETCH_SERVICE_METHODS_DESC}
      }
    })
  }

  retrieveServiceOperations(params: any) {
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'retrieveServiceOperations',
      pathParams: params.urlParams
    })
  }

  getServiceOperationParams(params: any) {
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'getServiceOperationParams',
      pathParams: params.urlParams,
      toasterInfo: {
        'error'  : { title: this.locale.MESSAGE_ERROR_TITLE, description: this.locale.MESSAGE_ERROR_FETCH_SERVICE_METHOD_PARAMS_DESC}
      }
    })
  }

  getServiceClasses(params: any) {
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'getServiceClasses',
      urlParams: params
    })
  }

  configureWebSocketService(connectionParams:any){
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'configureWebSocketService',
      data: connectionParams.data,
      urlParams: connectionParams.urlParams
    })
  }


  buildWebSocketService(connectionParams:any){
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'buildWebSocketService',
      data: connectionParams.data,
      urlParams: connectionParams.urlParams
    })
  }

  updateWebSocketService(connectionParams:any){
    return this.wmHttpService.execute({
      target: 'WebService',
      action: 'updateWebSocketService',
      data: connectionParams.data,
      urlParams: connectionParams.urlParams
    })
  }

  getWebSocketServiceDetails(connectionParams: any) {
    return this.wmHttpService.execute({
      target: "WebService",
      action: "getWebSocketServiceDetails",
      urlParams: connectionParams,
    });

  }

  constructor(private wmHttpService: WmHttpService, private projectService: ProjectService,private i18nService: I18nService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
    this.locale = this.i18nService.getMessages();
  }
}
